<!-- Pantalla Acceso Denegado -->
<div class="access-denied-container d-flex align-items-center justify-content-center min-vh-100">
  <div class="card shadow border-0" style="max-width: 500px; width: 100%; border-radius: 1rem;">
    
    <!-- Header con fondo rosado -->
    <div class="card-header text-center py-4 border-0" style="background-color: #f8d7da; border-radius: 1rem 1rem 0 0;">
      <i class="bi bi-shield-x mb-3" style="font-size: 4rem; color: #8b2635;"></i>
      <h2 class="mb-0" style="color: #8b2635; font-weight: 500;">
        Acceso Denegado
      </h2>
    </div>

    <!-- Body con fondo blanco -->
    <div class="card-body text-center p-4" style="border-radius: 0 0 1rem 1rem;">
      <!-- Mensaje principal -->
      <div class="mb-3">
        <h5 class="mb-3" style="color: #8b2635; font-weight: 500;">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Sin permisos suficientes
        </h5>
        <p class="text-muted mb-0" style="line-height: 1.6;">
          No tienes autorización para acceder a esta página.
        </p>
      </div>

      <!-- Mensaje adicional -->
      <div class="border-top pt-3 mt-3">
        <p class="text-muted mb-0" style="font-size: 0.9rem;">
          Si consideras que esto es un error, contacta al administrador del sistema.
        </p>
      </div>
    </div>

  </div>
</div>